import { useQuery } from 'hooks/useCustomQuery';
import { useSelector, useDispatch } from 'react-redux';
import getAllCompanies from 'API/Company/getAllCompanies';

const useGetAllCompanies = (setTableData) => {
    const { currentWholesaler, currentPartner } = useSelector(
        (state) => state.navigationLists,
    );
    const { currentScope } = useSelector((state) => state.login);

    const dispatch = useDispatch();

    return useQuery({
        // currentScope is sent on every request as a header (see
        // services/axios.js), but isn't reflected in the response unless the
        // query actually refetches — include it here so a scope change (#2649)
        // triggers a refetch instead of only refreshing on next page mount.
        queryKey: ['companies', currentScope],
        queryFn: async () => {
            return getAllCompanies(currentPartner, currentWholesaler);
        },
        onSuccess: (data) => {
            const sortedData = data.sort((a, b) => {
                const nameA = a.name?.toLowerCase() || '';
                const nameB = b.name?.toLowerCase() || '';
                if (nameA < nameB) return -1;
                if (nameA > nameB) return 1;
                return 0;
            });

            setTableData((prev) => ({
                ...prev,
                data: sortedData,
            }));
            dispatch({
                type: 'CHANGE_TABLE_LOADING',
            });
        },
        staleTime: 0,
    });
};

export default useGetAllCompanies;
